<template>
  <el-tree
    class="overflow-auto h-full cableModelTree"
    :props="treeProps"
    ref="modelTreeCableRef"
    :load="loadNode"
    highlight-current
    :lazy="true"
    show-checkbox
    :current-node-key="currentKey"
    :default-checked-keys="modelTreeProp.defaultCheckedKey"
    :default-expanded-keys="defaultExpandedKeys"
    @node-click="clickModelTree"
    node-key="node"
  ></el-tree>
</template>

<script>
import cloudRender from '../assets/js/model/index'
import { isJSONObj } from '../assets/js/scene/scene'

export default {
  props: ['player', 'sceneId'],
  data() {
    return {
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
        spaceSwapStatus: false, // 交换空间状态
      },
      defaultExpandedKeys: [],
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
      currentNode: {},
      currentKey: '',
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 模型树加载
    async loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.modelTreeProp.treeData.length === 0) {
          await this.getModelTreeDatas()
        }

        return resolve(this.modelTreeProp.treeData)
      }
      let res = []
      console.log(node, 'shu ygf---------------')

      if (node.data.isVirtual) {
        res = node.data.childs
      } else {
        const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
        console.log(result, 'shu ygf---------------')

        res = result?.children || []
      }
      if (res.length > 1000) {
        const shardingRes = []
        for (let i = 0; i < _.ceil(res.length / 1000); i += 1) {
          shardingRes.push({
            name: `${i * 1000 + 1}~${(i + 1) * 1000}`,
            checked: true,
            code: `${node.data.code}${i}`,
            node: `${node.data.node}${i}`,
            parentNode: node.data.node,
            visible: true,
            childs: res.slice(i * 1000, (i + 1) * 1000),
            isVirtual: true,
          })
        }
        res = shardingRes
      }
      const filterRes = _.filter(res, (el) => {
        return el?.name
      })
      // _.forEach(filterRes, async (el) => {
      //   if (
      //     isJSONObj(node.data.code) &&
      //     (JSON.parse(node.data.code).type === 'Root' ||
      //       JSON.parse(node.data.code).type === 'userData') &&
      //     el.itemType === 0 &&
      //     el.nodePtr
      //   ) {
      //     const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(el.nodePtr)
      //     if (nodeInfo.name) {
      //       el.name = nodeInfo.name
      //     }
      //     el.code = nodeInfo.code
      //   }
      // })

      resolve(filterRes)
    },
    locationNodeVisual(node) {
      this.player.Native.Camera.moveToNode(node, 2)
      this.player.Native.Node.selectNodes([node])
    },
    locationNode(id) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.modelTreeCableRef.setCurrentKey(id)
          setTimeout(() => {
            const node = document.getElementsByClassName('cableModelTree')[0]
            const currentNode = document.getElementsByClassName('is-current')[0]
            node.scrollTo({
              top: currentNode.offsetTop,
            })
          }, 600)
        }, 500)
      })
    },
    async expendNode(node, doLocation) {
      console.log(node, doLocation, 'node, doLocation----')

      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      if (node.node === rootChild.children[0]?.node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.clickModelTree(this.currentNode, { checked: true }, doLocation)

          this.locationNode(this.currentNode.node)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(node.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', node.node])
        }
        await this.expendNode(parentInfo, doLocation)
        if (!this.defaultExpandedKeys.includes(parentInfo.node)) {
          // 展开
          this.defaultExpandedKeys.push(parentInfo.node)
        }
        if (!_.isNil(expandIndex) && expandIndex > -1) {
          this.defaultExpandedKeys.push(
            `${parentInfo.node}${
              expandIndex % 1000 === 0 ? expandIndex / 1000 : _.ceil(expandIndex / 1000) - 1
            }`
          )
        }
      }
    },
    clickModelTree(data, node, doLocation) {
      console.log(data, 'clickModelTree------')

      this.currentKey = data.node
      this.locationNodeVisual(data.node)
      this.locationNode(data.node)
    },

    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.modelTreeProp.treeData = currentProperty.children
      this.modelTreeProp.modelTreeLoadEnd = true
    },
    async watchMsg(data) {
      console.log(data, 'wEFERGVrftdht')

      if (data.node) {
        this.currentNode = data
        await this.expendNode(data)
      }
    },
    async getTreeCheck() {
      const nodes = this.$refs.modelTreeCableRef.getCheckedNodes()
      const angle = await this.player.Native.Camera.currentParam()
      const codes = nodes.map((o) => {
        return o.code
      })
      console.log(nodes, '--------------')

      return nodes.map((o) => {
        const parent = this.$refs.modelTreeCableRef.getNode(o.parentItem)?.data?.code
        return {
          name: o.name,
          code: o.code,
          parentCode: parent && codes.includes(parent) ? parent : '',
          sceneId: this.sceneId,
          angle: JSON.stringify(angle),
        }
      })
    },
  },
  async mounted() {
    this.player.Native.OperatingMode.EventPickUpNode.connect(this.watchMsg)
  },
  beforeDestroy() {
    this.player.Native.OperatingMode.EventPickUpNode.disconnect(this.watchMsg)
  },
}
</script>

<style>
</style>
